var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "hmim-svg homeIconSvg w-[20px] h-auto",
    width: 22,
    height: 22,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.65839 6.64433C5.65839 6.13631 5.24663 5.72476 4.73882 5.72476C4.23081 5.72476 3.81925 6.13633 3.81925 6.64433V17.6311C3.81925 19.3526 5.21464 20.7482 6.93608 20.7482H17.9234C19.6448 20.7482 21.0402 19.3526 21.0402 17.6311V6.64433C21.0402 6.13631 20.6284 5.72476 20.1206 5.72476C19.6128 5.72476 19.2011 6.13631 19.2011 6.64433V17.6311C19.2011 18.3369 18.6291 18.909 17.9234 18.909H6.93608C6.23053 18.909 5.65839 18.3369 5.65839 17.6311V6.64433Z",
    fill: "#707494",
    stroke: "#707494",
    strokeWidth: 0.191097
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4604 11.633C10.4604 10.5456 11.342 9.66406 12.4294 9.66406C13.5169 9.66406 14.3984 10.5456 14.3984 11.633C14.3984 12.7205 13.5169 13.602 12.4294 13.602C11.342 13.602 10.4604 12.7205 10.4604 11.633Z",
    fill: "#707494"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1626 2.78308L13.1627 2.78309L22.8896 9.59186C23.3057 9.88313 23.879 9.78193 24.1702 9.36587C24.4615 8.9498 24.3603 8.3765 23.9443 8.08524L14.2175 1.27647L14.2175 1.27646C13.1441 0.525242 11.7157 0.525236 10.6424 1.27647L10.6968 1.35419L10.6424 1.27647L0.915657 8.08524L0.97045 8.16352L0.915654 8.08524C0.499597 8.3765 0.398393 8.9498 0.689664 9.36587C0.980925 9.78193 1.55422 9.88313 1.97029 9.59186L11.697 2.78309L11.6422 2.70481L11.697 2.78308C12.137 2.47504 12.7227 2.47504 13.1626 2.78308Z",
    fill: "#707494",
    stroke: "#707494",
    strokeWidth: 0.191097
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.9c50b86fd96c5060a914a7bc5ff9abef.svg";
export { ForwardRef as ReactComponent };